module.exports = __webpack_public_path__ + "static/media/serv-wed-small.8a09950d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/serv-wed-small.jpg
// module id = 487
// module chunks = 0